<template>
    <div
        class="t-main main" 
        @click.passive="handleMainContainerClick"
        :style="componentStyles"
    >
        <ALoader v-if="mapLoading" />
        <slot name="overlay"/>
        <div class="main-container" role="main">
            <slot name="view" />
            <OTMap
                :key="lastModified"
                :style="mapVisibleClass"
            />
        </div>
        <slot name="modal" />
        <slot name="player" />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';
    
import ALoader from '../../atoms/a-loader/a-loader';
import OTMap from '../../unique-organisms/o-t-map/o-t-map';

export default {
    name: 'TTerminal',
    components: {
        OTMap,
        ALoader
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        ...mapState({
            mapLoading: state => state.mapLoading,
            lastModified: state => state.lastModified,
        }),
        mapParams() {
            return this.getMapConfigProp('theme_params.mapParams') || {};
        },
        mapVisibleClass() {
            return this.$route.name === 'terminal.standard.guide'
                ? {
                    position: 'absolute',
                    top: '113px',
                    left: '324px',
                    height: '797px',
                    width: '1570px',
                    ...this.mapParams
                } : null
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.TTerminal.styles`) || {};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.TTerminal.styles') || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        }
    },
    methods: {
        handleMainContainerClick() {
            this.$emit('onMainContainerClick', true);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
